import { SonarScopedDashboardPage } from './sonar/shared/components/SonarScopedDashboardPage';

export const SonarTeamViewPage = () => (
  <SonarScopedDashboardPage initialScope="team" />
);